var Utils = {

  /* COLORS */

  // http://stackoverflow.com/questions/2353211/hsl-to-rgb-color-conversion
  rgbToHsl: function(r, g, b){
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;

    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch(max){
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }

    return {
      h: h,
      s: s,
      l: l
    };
  },

  hexToRgb: function(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
  },

  alphaHex: function(hex, alpha) {
    let rgb = this.hexToRgb(hex);
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
  },


  /* URL */

  // https://stackoverflow.com/questions/8486099/how-do-i-parse-a-url-query-parameters-in-javascript
  getUrlParams: function(url) {
    if (!url) url = location.href;
    const question = url.indexOf("?");
    let hash = url.indexOf("#");
    if (hash == -1 && question == -1) return {};
    if (hash == -1) hash = url.length;
    const query = question == -1 || hash == question + 1
                ? url.substring(hash)
                : url.substring(question + 1, hash);
    const result = {};
    query.split("&").forEach(part => {
      if (!part) return;
      part = part.split("+").join(" "); // replace every + with space, regexp-free version
      const eq = part.indexOf("=");
      let key = eq > -1 ? part.substr(0, eq) : part;
      const val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : "";
      const from = key.indexOf("[");
      if (from == -1) result[decodeURIComponent(key)] = val;
      else {
        const to = key.indexOf("]", from);
        const index = decodeURIComponent(key.substring(from + 1, to));
        key = decodeURIComponent(key.substring(0, from));
        if (!result[key]) result[key] = [];
        if (!index) result[key].push(val);
        else result[key][index] = val;
      }
    });
    return result;
  },

  getUrlParamsWithRegex: function(url, regex) {
    const urlParams = this.getUrlParams(url);
    const filteredResult = {}

    for (const [param, value] of Object.entries(urlParams)) {
      if (param.match(regex)) {
        filteredResult[param] = value;
      }
    }

    return filteredResult;
  },

  /**
   * @param {String} url Original URL
   * @param {Object} params Ovrride the URL with these query parameters
   * @returns {String} Edited URL
   */
  setUrlParams: function(url, params) {
    if (!url) url = location.href;
    let question = url.indexOf("?");
    let hash = url.indexOf("#");
    if (question == -1) question = url.length;
    if (hash == -1) hash = url.length;
    const parts = {
      base: url.substring(0, question),
      query: url.substring(question, hash).replace(/^\?/, ''),
      hash: url.substring(hash, url.length).replace(/^\#/, ''),
    };
    let newQuery = Object.keys(params).map(function(k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&');
    return parts.base + (newQuery.length ? '?' + newQuery : '') + (parts.hash.length ? '#' + parts.hash : '');
  },


  /* STRINGS */

  capitalize: function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },


  /* LOCAL STORAGE */

  _setSafeStorage: function(key, value, session) {
    let storage;
    try {
      storage = session ? sessionStorage : localStorage;
      storage.removeItem(key)
    } catch(e) { }

    try {
      return storage.setItem(key, JSON.stringify(value))
    } catch(e) {
      return null
    }
  },

  _getSafeStorage: function(key, session) {
    try {
      let storage = session ? sessionStorage : localStorage;
      return JSON.parse(storage.getItem(key))
    } catch(e) {
      return null
    }
  },

  _storage: function(key, value, session) {
    key = 'slaask-widget-' + key;
    if (this.defined(value)) {
      this._setSafeStorage(key, value, session);
    }
    return this._getSafeStorage(key, session);
  },

  localStorage: function(key, value) {
    return this._storage(key, value, false);
  },

  sessionStorage: function(key, value) {
    return this._storage(key, value, true);
  },

  /* DOM */

  htmlString: function(html) {
    let temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.children[0];
  },

  addClass: function(elements, className) {
    if(elements) {
      if (typeof elements == "string") throw "Getting an element from its id has been disabled since the introduction of the chat loader.";
      elements = typeof elements.length == "number" ? elements : [elements];
      this.forEach(elements, element => {
        if (element && !this.hasClass(element, className))
          element.className += " " + className;
      });
    }
  },

  removeClass: function(elements, className, strict) {
    if(elements) {
      if (typeof elements == "string") throw "Getting an element from its id has been disabled since the introduction of the chat loader.";
      elements = typeof elements.length == "number" ? elements : [elements];
      this.forEach(elements, element => {
        if (element) {
          let reg = new RegExp('(\\s|^)(' + className + ')(\\s|$)', 'g');
          element.className = element.className.replace(reg, '$1').trim();
        }
      });
    }
  },

  hasClass: function(element, className) {
    if (element) {
      let reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
      return reg.test(element.className);
    }
  },

  removeElement(element) {
    if (element.parentElement)
      element.parentElement.removeChild(element);
  },

  restartAnimations(element) {
    element.style.display = "none";
    void element.offsetWidth;
    element.style.display = "";
  },

  // Please use Utils.dataSet instead of element.dataset as it will break IE9 compatibility
  dataSet(element, prop, value) {
    let dataProp = "data-" + prop;
    if (this.defined(value)) {
      element.setAttribute(dataProp, value);
    }
    return element.getAttribute(dataProp);
  },

  closest(element, selector) {
    if (element.closest) return element.closest(selector);
    else {
      if (!element.ownerDocument.documentElement.contains(element)) return null;
      do {
        if (this.matches(element, selector)) return element;
        element = element.parentElement || element.parentNode;
      } while (element !== null && element.nodeType === 1);
      return null;
    }
  },

  matches(element, selector) {
    if (element.matches) return element.matches(selector);
    var matches = (element.document || element.ownerDocument).querySelectorAll(selector);
    var i = matches.length;
    while (--i >= 0 && matches.item(i) !== element) {}
    return i > -1;
  },

  loadCssFile(doc, url) {
    return new Promise((resolve, reject) => {
      let cssTag   = doc.createElement('link');

      cssTag.type      = "text/css";
      cssTag.rel       = "stylesheet";
      cssTag.className = "slaask-style-sheet";
      cssTag.addEventListener('load', () => { resolve(cssTag); });
      cssTag.href      = url;
      doc.head.appendChild(cssTag);
    });
  },

  appendCss(doc, css) {
    return new Promise((resolve, reject) => {
      if (css == "") resolve();
      else {
        let resolved     = false;
        let uniqueResolve = function() {
          if (!resolved) {
            resolved = true;
            resolve(cssTag);
          }
        };

        let cssTag       = doc.createElement('style');
        cssTag.type      = "text/css";
        cssTag.className = "slaask-style-sheet";
        cssTag.addEventListener('load', uniqueResolve);
        cssTag.innerHTML = css;
        doc.head.appendChild(cssTag);

        // Fix for browsers not fireing load event
        setTimeout(uniqueResolve, 500);
      }
    });
  },

  computedOuterHeight(element) {
    if (this.isIe9) {
      return element.offsetHeight;
    }
    else {
      let computed = element.ownerDocument.defaultView.getComputedStyle(element, null);
      if (computed["height"] == "auto") return element.offsetHeight;
      else return parseFloat(computed["height"])
                  + (computed["boxSizing"] == "border-box" && Platform.name != "IE"
                    ? 0
                    : parseFloat(computed["padding-bottom"]) + parseFloat(computed["padding-top"]));
    }
  },

  // https://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery
  insertAtCaret(textareaElement, text) {
    var txtarea = textareaElement;

    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br = ((txtarea.selectionStart || txtarea.selectionStart == '0') ?
      "ff" : (document.selection ? "ie" : false));
    if (br == "ie") {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart('character', -txtarea.value.length);
      strPos = range.text.length;
    } else if (br == "ff") {
      strPos = txtarea.selectionStart;
    }

    var front = (txtarea.value).substring(0, strPos);
    var back = (txtarea.value).substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br == "ie") {
      txtarea.focus();
      var ieRange = document.selection.createRange();
      ieRange.moveStart('character', -txtarea.value.length);
      ieRange.moveStart('character', strPos);
      ieRange.moveEnd('character', 0);
      ieRange.select();
    } else if (br == "ff") {
      txtarea.selectionStart = strPos;
      txtarea.selectionEnd = strPos;
      txtarea.focus();
    }

    txtarea.scrollTop = scrollPos;
  },


  /* OBJECTS */

  // Note that passing an undefined variable will throw an error
  // Only pass properties here
  exists: function(prop) {
    return typeof prop != "undefined" && prop != null;
  },

  defined: function(prop) {
    return typeof prop != "undefined";
  },

  autoFeed: function(obj, params, data) {

    // QUICKEST
    // obj, ["property"], dataHashFromServer
    if (data && Array.isArray(params)) {
      for (let id = 0 ; id < params.length ; id++) {
        obj[params[id]] = data[params[id]];
      }
    }

    // ALLOWS DEFAULT VALUES
    // obj, {"property": defaultValue}, dataHashFromServer
    else if (data && typeof params == "object") {
      for (let id in params) {
        if ({}.hasOwnProperty.call(params, id)) {
          obj[id] = this.defined(data[id])
                            ? data[id]
                            : params[id];
        }
      }
    }

    // ALLOWS CUSTOM DATA
    // obj, {"property": [computedValue, defaultValue]}
    else if (typeof params == "object") {
      for (let id in params) {
        if ({}.hasOwnProperty.call(params, id)) {
          obj[id] = this.exists(params[id][0])
                    ? params[id][0]
                    : ( this.defined(obj[id])
                        ? obj[id]
                        : params[id][1]);
        }
      }
    }
  },

  feedIfEmpty: function(obj, data) {
    for (let prop in data) {
      if (!this.defined(obj[prop])) obj[prop] = data[prop];
    }
  },

  // Because you're too lazy to check if the container object is defined
  deepGet: function(obj, keys) {
    if (keys.length > 1) {
      if (!obj[keys[0]] || typeof obj[keys[0]] != "object") return;
      else return this.deepGet(obj[keys[0]], keys.splice(1));
    }
    else return obj[keys[0]];
  },

  deepSet: function(obj, keys, value) {
    if (!Utils.exists(obj)) obj = {};
    if (keys.length > 1) {
      if (!obj[keys[0]]) obj[keys[0]] = {};
      return this.deepSet(obj[keys[0]], keys.splice(1), value);
    }
    else obj[keys[0]] = value;
  },

  clone: function(obj) {
    return typeof obj == "object" ? JSON.parse(JSON.stringify(obj)) : obj;
  },

  argumentsToArray(args) {
    return this.clone(Array.prototype.slice.call(args).sort());
  },


  /* ARRAYS */

  last: function(array) {
    return array.length ? array[array.length - 1] : null;
  },

  ensureArray(obj) {
    return Array.isArray(obj)
      ? obj
      : this.defined(obj)
        ? [obj]
        : [];
  },

  /**
   * forEach
   * Will act as Array.forEach, but will also work with objects.
   * Please use this function to avoid for (let ... in ...)
   * @param  {object}   arrayOrObj Array to Object to iterate
   * @param  {Function} cb         Function to execute for each element, taking three arguments:
   *                               - currentValue, index, array
   * @param  {object}   thisArg    Value to use as "this"
   */
  forEach: function(arrayOrObj, cb, thisArg) {
    for (let id in arrayOrObj) {
      if ({}.hasOwnProperty.call(arrayOrObj, id)) {
        cb.call(thisArg, arrayOrObj[id], id, arrayOrObj);
      }
    }
  },


  /* COOKIES */

  getCookie: function(cookieName) {
    if (this._bufferingCookies && this._bufferedCookies[cookieName]) {
      return this._bufferedCookies[cookieName].cookieValue;
    }
    var doc = this._getClosestDocumentWithHost();
    var name  = cookieName + "=";
    var cook  = doc.cookie.split(';');
    for(var i = 0; i < cook.length; i++) {
      var c = cook[i];
      while (c.charAt(0) == ' ') c = c.substring(1);
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  },

  setCookie: function(cookieName, cookieValue, cookieDuration) {
    if (this._bufferingCookies) {
      this._bufferedCookies[cookieName] = {
        cookieValue: cookieValue,
        cookieDuration: cookieDuration
      };
      return cookieValue;
    }
    else {
      var doc = this._getClosestDocumentWithHost();
      if(cookieDuration == undefined) { cookieDuration = 380 }
      var d = new Date();
      d.setTime(d.getTime() + (cookieDuration * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      var samesite = 'SameSite=Lax;';

      if (this.cookiesOnSubdomains) {
        var splited_domain  = doc.domain.split('.');
        var i               = 0;
        while(i<(splited_domain.length-1)){
          domain = splited_domain.slice(-1-(++i)).join('.');
          this.log('Cookie created on ' + domain);
          doc.cookie = cookieName + "=" + cookieValue + "; domain=" + domain + "; path=/; " + expires + '; ' + samesite;
        }

        this.log('Cookie created on ' + doc.domain);
        doc.cookie = cookieName + "=" + cookieValue + "; domain=" + doc.domain + "; path=/; " + expires + '; ' + samesite;
      } else {
        this.log('Cookie created on ' + doc.domain);
        doc.cookie = cookieName + "=" + cookieValue + "; path=/; " + expires + '; ' + samesite;
      }

      return cookieValue;
    }
  },

  _bufferingCookies: false,
  _bufferedCookies: {},

  /**
   * Instead of saving the cookies right away, they will be store temporarily.
   * Once the buffer is disabled, the cookies will be written permanently.
   * This function allows to prevent cookies being written if the initialization
   * failed.
   */
  bufferCookies: function(enabled) {
    if (this._bufferingCookies) {
      this._bufferingCookies = false;
      Object.keys(this._bufferedCookies).forEach(cookieName => {
        const bufferedCookie = this._bufferedCookies[cookieName];
        this.setCookie(
          cookieName,
          bufferedCookie.cookieValue,
          bufferedCookie.cookieDuration,
        );
      })
    }
    else {
      this._bufferingCookies = true;
    }
  },

  shouldOverrideCookie: function() {
    let doc       = this._getClosestDocumentWithHost();
    let url       = doc.location.href
    let urlParts  = url.split('?')
    let newCookie = false

    if (url.match('slaask-cookie-token') && urlParts.length >= 2) {
      let urlBase     = urlParts.shift()
      let queryString = urlParts.join('?')
      let urlHash     = queryString.split('#')[1]
      queryString     = queryString.split('#')[0]

      let prefix  = 'slaask-cookie-token='
      let pars    = queryString.split(/[&;]/g)

      for (let i = 0; i < pars.length; i++) {
        if (pars[i].lastIndexOf(prefix, 0) != -1) {
          newCookie = pars[i].replace('slaask-cookie-token=', '')
          pars.splice(i, 1);
        }
      }

      if (pars.length > 0) { url = urlBase + '?' + pars.join('&') } else { url = urlBase }
      if (urlHash && urlHash.length > 0) { url = url + '#' + urlHash }

      window.history.pushState('', doc.title, url);
    }

    return newCookie
  },

  // IE fix with iframes, document.cookie on about:blank iframe is always empty
  _getClosestDocumentWithHost() {
    var doc = document;
    while (!doc.location.host && doc.defaultView.parent.document != doc) {
      doc = doc.defaultView.parent.document;
    }
    return doc;
  },

  /* REGEX */

  escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  },

  /* PARSING */

  parseLinksInMessage: function(message) {
    message = message.replace(/(\s|^)(https?:\/\/\S+)(\s|$)/gi, "$1<$2>$3")
                     .replace(/<?(https?:\/\/.*?\.(?:png|jpg|gif|svg|jpeg))(\?([^\s]*?))?(\|(.*?))>?(\s|$)/gi, '![$5]($1$2)')
                     .replace(/<?(https?:\/\/.*\.(?:png|jpg|gif|svg|jpeg))(\?([^\s]*?))?>?(\s|$)/gi, '![attachment]($1$2)$4')

    return message
  },

  humanize: function(text) {
    return text.toString().toLowerCase()
      .replace(/[_-]/g, ' ')
      .replace('.', ' ')
      .replace(/(?:^|\s)\S/g, (a) => {
        return a.toUpperCase();
      });
  },



  /* LOGS */

  enableLogs: function(enable = true) {
    this._logsEnabled = enable;
    if (enable) {
      this.eventHappened('logsEnabled');
    }
  },

  _log: async function(message, level, attachments = []) {
    if (this._logsEnabled !== false) {
      let time = new Date().toISOString().split("T")[1].split("Z")[0];
      let caller;
      if (Platform.name == "Chrome")
        caller = (new Error()).stack.split("\n")[3].trim().split(" ")[1];
      else if (Platform.name == "Firefox")
        caller = (new Error()).stack.split("\n")[2].trim().split("@")[0].split("/")[0];
      else
        caller = "Chatbox";

      if (this._logsEnabled === null) {
        await this.event('logsEnabled');
        time += " (delayed after log activation)";
      }

      let attachmentsStr = '';
      for (let id = 0 ; id < attachments.length ; id++) {
        attachmentsStr += '[' + attachments[id].constructor.name + '] ';
      }
      if (attachmentsStr.length)
        attachmentsStr = EmojiMap.paperclip + attachmentsStr;


      // A hidden "slaask" is added to each logs for easy filter
      if (!~["Chrome", "Firefox"].indexOf(Platform.name)) {
        (window.top.console.debug || window.top.console.log)(message);
      }
      else {
        let args = [`%c${caller} %c${time} ${attachmentsStr} %cslaaskxeno\n%c${level == 'booyah' ? EmojiMap.unicorn_face + ' ' : ''}${typeof message == 'object' && message != null && !(message instanceof Error) ? message.constructor.name : message}`, "color: #E01765; font-weight: normal;", "color: rgba(128, 128, 128, 1); font-weight: normal;", "color: rgba(0, 0, 0, 0); font-size: 3px; font-weight: normal;", "font-weight: normal;"];
        if (level == 'error')
          console.error.apply(console, args);
        else if (level == 'warn')
          console.warn.apply(console, args);
        else {
          if (level == "booyah")
            args[4] = "font-size: 1.3em; font-weight: bold; border-left: 0.2em rgba(224, 23, 101, 0.3) solid; padding-left: 0.7em;"
          console.groupCollapsed.apply(console, args);
          for (let id = 0 ; id < attachments.length ; id++)
            console.log(attachments[id])
          console.trace("Stack");
          console.groupEnd();
        }
      }

      if (typeof message == "object") console.log(message);
    }
    else {
      if (level == 'error')
        this.publicError(message);
    }
  },

  log: function(message, ...attachments) {
    this._log(message, 'log', attachments);
  },

  warn: function(message) {
    this._log(message, 'warn');
  },

  /**
   * error
   * Errors are only displayed in debug mode.
   * Use `publicLog` to log in prod mode.
   * @param  {string} message
   */
  error: function(message) {
    this._log(message, 'error');
  },

  trace: function() {
    this._log('', 'log');
    console.trace();
  },

  booyah: function(message = "BOOYAH", ...attachments) {
    this._log(message, 'booyah', attachments);
  },

  logState: function(conversation, stateName) {
    this._log(`${EmojiMap.red_circle}[${conversation.id}] State ${stateName}`, 'log', [conversation]);
  },

  publicLog: function(msg) {
    console.log(this.publicLogPrefix + msg);
  },

  publicWarn: function(msg) {
    console.warn(this.publicLogPrefix + msg);
  },

  publicError: function(msg) {
    if (msg instanceof Error) {
      msg.message = this.publicLogPrefix + msg.message;
      console.error(msg);
    }
    else {
      console.error(this.publicLogPrefix + msg);
    }
  },

  publicLogPrefix: 'Chatbox log: ',


  /* CACHE */

  // Caches results for later
  cacheSync(group, name, fct) {
    if (!this._cache[group]) this._cache[group] = {};
    return this._cache[group][name] =
              this.defined(this._cache[group][name])
              ? this._cache[group][name]
              : fct();
  },

  emptyCache(group) {
    this._cache[group] = {};
  },


  /* ASYNC */

  // Ensures an event happened before continuing

  // await Utils.event(name)
  event: function(eventName) {
    return new Promise((resolve, reject) => {
      if (!this._eventAwaiters[eventName]) this._eventAwaiters[eventName] = [];
      if (this._eventAwaiters[eventName] === true) resolve();
      else {
        this._eventAwaiters[eventName].push(resolve);
      }
    });
  },

  eventHappened: function(eventName) {
    if (Array.isArray(this._eventAwaiters[eventName])) {
      this._eventAwaiters[eventName].forEach(resolve => {
        resolve();
      });
    }
    this._eventAwaiters[eventName] = true;
  },

  // "handler" takes "resolve" and "reject" as arguments
  queue: function(queueName, handler) {
    if (!this._promisesQueue[queueName]) this._promisesQueue[queueName] = [];

    let runQueue = async () => {
      while (this._promisesQueue[queueName][0]) {
        await new Promise(this._promisesQueue[queueName][0]);
        this._promisesQueue[queueName].shift();
      }
    };

    let promisesLength = this._promisesQueue[queueName].length;
    this._promisesQueue[queueName].push(handler);
    if (!promisesLength) runQueue();
  },


  /* TIMEOUTS */

  /**
   * uniqueTimeout
   * Clears the previous timeout declared with the same name
   * @param  {string}   name          Unique name
   * @param  {function} handler       Handler to pass to the setTimeout function
   * @param  {number}   time          Time in ms to pass to the setTimeout function
   * @param  {boolean}  firstInstant  The first will be instant, but the second will be "time" ms after
   * @return {number}                 The return value from the setTimeout function
   */
  uniqueTimeout: function(name, handler, time, firstInstant = false) {
    let instant = firstInstant && !this._uniqueTimeouts[name];
    if (this._uniqueTimeouts[name])
      clearTimeout(this._uniqueTimeouts[name]);
    if (instant) handler();
    this._uniqueTimeouts[name] = setTimeout(() => {
      delete this._uniqueTimeouts[name];
      if (!instant) handler();
    }, time);
  },

  clearTimeout: function(name) {
    if (this._uniqueTimeouts[name]) {
      clearTimeout(this._uniqueTimeouts[name]);
      delete this._uniqueTimeouts[name];
    }
  },

  uniqueInterval: function(name, handler, time) {
    if (this._uniqueIntervals[name])
      clearInterval(this._uniqueIntervals[name]);
    this._uniqueIntervals[name] = setInterval(() => {
      handler();
    }, time);
  },

  clearInterval: function(name) {
    if (this._uniqueIntervals[name]) {
      clearInterval(this._uniqueIntervals[name]);
      delete this._uniqueIntervals[name];
    }
  },

  clearTimeoutsIntervals: function() {
    if (this._uniqueTimeouts) {
      this.forEach(this._uniqueTimeouts, (timeout, name) => {
        this.clearTimeout(name);
      });
    }
    if (this._uniqueIntervals) {
      this.forEach(this._uniqueIntervals, (timeout, name) => {
        this.clearInterval(name);
      });
    }
  },

  delay: function(ms) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, ms);
    });
  },


  /* TIME */

  // Utils.time.h(2)
  time: {
    d: n => n * 1000 * 60 * 60 * 24,
    h: n => n * 1000 * 60 * 60,
    m: n => n * 1000 * 60,
    s: n => n * 1000
  },

  getNumberOfWeek: function(date = false) {
    if (date) {
      date        = new Date(date);
    } else {
      date        = new Date();
    }
    var day       = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    var dayNum    = day.getUTCDay() || 7;
    day.setUTCDate(day.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(day.getUTCFullYear(),0,1));
    return Math.ceil((((day - yearStart) / 86400000) + 1)/7);
  },


  /* COMPATIBILITY */

  isIe9: Platform.name == "IE" && document.documentMode == 9,
  isIe10: Platform.name == "IE" && document.documentMode == 10,


  /* OTHERS */

  generateRandomToken: function(repeat = 4) {
    return (new Array(repeat)).fill(null).map(x => Math.random().toString(36).substr(2)).join("");
  },

  shuffleArray(array) {
    var newArray = JSON.parse(JSON.stringify(array))
    for (var i = newArray.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = newArray[i];
      newArray[i] = newArray[j];
      newArray[j] = temp;
    }
    return newArray;
  },


  reset() {
    this.clearTimeoutsIntervals();
    Utils._logsEnabled        = null;
    Utils._cache              = {};
    Utils._eventAwaiters      = {};
    Utils._uniqueTimeouts     = {};
    Utils._uniqueIntervals    = {};
    Utils.cookiesOnSubdomains = false;
    Utils._promisesQueue      = {};
  }

};

Utils.reset();

Utils.NON_STRICT      = false;
Utils.STRICT          = true;
